import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isEditBoxNotecardPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { SPECIAL_PRODUCT_TYPES } from 'swag-common/constants/product.constants';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { onBoxNotecardDesignClose } from '../../../redux/box-notecard-editor/box-notecard-editor.actions';
import { resetPopup } from '../../../redux/box-notecard-editor/box-notecard-editor.actions';
import { toggleSpecialProductInBox } from '../../../redux/box-builder/box-builder.actions';
import { stepSelector, selectedBoxItemsIdSelector } from '../../../redux/box-notecard-editor/box-notecard-editor.selectors';
import { EditBoxNotecardPopupComponent } from './edit-box-notecard-popup';
const mapStateToProps = createStructuredSelector({
  open: isEditBoxNotecardPopupShownSelector,
  step: stepSelector,
  boxItemsId: selectedBoxItemsIdSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: (event, reason) => {
    if (reason) {
      return;
    }
    dispatch(onBoxNotecardDesignClose());
  },
  onAddNotecard: boxItemsId => {
    //ADD NOTECARD WITHOUT DESIGN ITEM AND UPDATE CART
    dispatch(hidePopup());
    dispatch(resetPopup());
    dispatch(toggleSpecialProductInBox(boxItemsId, SPECIAL_PRODUCT_TYPES.BOX_NOTECARD, {
      isNotecardPicked: true
    }));
  },
  onDeleteNotecard: boxItemsId => {
    //UPDATE CART WITHOUT NOTECARD
    dispatch(hidePopup());
    dispatch(toggleSpecialProductInBox(boxItemsId, SPECIAL_PRODUCT_TYPES.BOX_NOTECARD, {
      isNotecardPicked: false
    }));
    dispatch(resetPopup());
  }
});
export const EditBoxNotecardPopup = connect(mapStateToProps, mapDispatchToProps)(EditBoxNotecardPopupComponent);